export namespace App.Enums.ComplianceProfile {
    export enum YesNoOption {
        YES = 'yes',
        NO = 'no',
        NULL = null,
    }
}
export namespace App.Enums.ComplianceProfile.ECSP {
    export enum DividendsAnswerOption {
        EQUITY = 'equity',
        DEBT_CAPITAL = 'debt_capital',
    }

    export enum FinancialEducation {
        PROFESSIONAL_EXPERIENCE = 'professional_experience',
        RELEVANT_DEGREE = 'relevant_degree',
        BOTH = 'both',
        NONE = 'none',
    }

    export enum GoodLongTermInvestmentAnswerOption {
        COMPANY_INVESTMENT_PORTFOLIO = 'company_investment_portfolio',
        SCATTER_INVESTMENTS = 'scatter_investments',
    }

    export enum HigherInterestRatesAnswerOption {
        SECURE_INVESTMENT = 'secure_investment',
        RISK_INVESTMENT = 'risk_investment',
    }

    export enum InvestmentFrequencyOption {
        LESS_THAN_5_TIMES = 'less_than_5_times',
        MORE_THAN_5_TIMES = 'more_than_5_times',
        NO_ANSWER = 'no_answer',
    }

    export enum InvestmentGoalAnswerOption {
        WEALTH_BUILDING = 'wealth_building',
        SPECULATIVE_INVESTMENTS = 'speculative_investments',
        NO_ANSWER = 'no_answer',
    }

    export enum InvestmentHorizonAnswerOption {
        TWO_YEARS = 'two_years',
        UP_TO_5_YEARS = 'up_to_5_years',
        MORE_THAN_5_YEARS = 'more_than_5_years',
        NO_ANSWER = 'no_answer',
    }

    export enum InvestmentsOutsideStockMarketAnswerOption {
        LOW_RISK = 'low_risk',
        HIGH_RISK = 'high_risk',
        HIGH_PROPORTION = 'high_proportion',
    }

    export enum MostStartupsAnswerOption {
        SUCCESSFUL = 'successful',
        FAIL = 'fail',
    }

    export enum ProfitParticipationCertificateAnswerOption {
        PARTICIPATE_PROFITS_LOSSES = 'participate_profits_losses',
        FIXED_INTEREST_AMOUNT = 'fixed_interest_amount',
        TRANSFER_TO_COMPANY = 'transfer_to_company',
    }

    export enum ReturnOnInvestmentAnswerOption {
        LESS_THAN_5_YEARS = 'less_than_5_years',
        MORE_THAN_5_YEARS = 'more_than_5_years',
    }

    export enum SecureInvestmentAnswerOption {
        BOND_BRD = 'bond_brd',
        BOND_US_TREASURY = 'bond_us_treasury',
        VW_SHARE = 'vw_share',
    }

    export enum StartupInvestingAnswerOption {
        HIGH_RETURN_LOW_RISK = 'high_return_low_risk',
        LOSS = 'loss',
        GROWTH = 'growth',
    }

    export enum StocksBankruptCompanyAnswerOption {
        REFUND = 'refund',
        LOSS = 'loss',
    }

    export enum SubordinatedFinancialInstrumentsAnswerOption {
        INSOLVENCY_QUOTE = 'insolvency_quote',
        EQUAL_WITH_OTHER_CREDITORS = 'equal_with_other_creditors',
        LOSE_INVESTMENT = 'lose_investment',
    }

    export enum SustainabilityAnswerOption {
        VERY_TRUE = 'very_true',
        APPLIES = 'applies',
        DOES_NOT_APPLY = 'does_not_apply',
        NO_ANSWER = 'no_answer',
    }

    export enum YesNoDenyOption {
        YES = 'yes',
        NO = 'no',
        NO_ANSWER = 'no_answer',
    }
}
export namespace App.Http.Resources.Campaign.Manage {
    export type CampaignDetailedResource = {
        resource: any
        with: Array<any>
        additional: Array<any>
    }
}
export namespace App.Services.ComplianceProfile.ECSP {
    export type EcspLegalProfileComplianceProfileDto = {
        investor_classification: App.Services.ComplianceProfile.ECSP.Categories.EcspInvestorClassificationDto
        risk: App.Services.ComplianceProfile.ECSP.Categories.EcspRiskDto
        financial_situation: App.Services.ComplianceProfile.ECSP.Categories.EcspFinancialSituationDto
    }
    export type EcspNaturalProfileComplianceProfileDto = {
        investorClassification: App.Services.ComplianceProfile.ECSP.Categories.EcspInvestorClassificationDto
        experience: App.Services.ComplianceProfile.ECSP.Categories.Natural.EcspExperienceDto
        risk: App.Services.ComplianceProfile.ECSP.Categories.EcspRiskDto
        investmentGoals: App.Services.ComplianceProfile.ECSP.Categories.Natural.EcspInvestmentGoalsDto
        financialSituation: App.Services.ComplianceProfile.ECSP.Categories.EcspFinancialSituationDto
    }
}
export namespace App.Services.ComplianceProfile.ECSP.Categories {
    export type EcspFinancialSituationDto = {
        annual_net_income: number | null
        liquid_funds: number | null
        annual_financial_commitments: number | null
        net_worth: number | null
        loss_bearing_capacity: number | null
    }
    export type EcspInvestorClassificationDto = {
        expert_investor_treatment: App.Enums.ComplianceProfile.YesNoOption | null
        self_disclosure: any | null
    }
    export type EcspRiskDto = {
        no_answer: boolean | null
        startup_investing: App.Enums.ComplianceProfile.ECSP.StartupInvestingAnswerOption | null
        investments_outside_stock_market: App.Enums.ComplianceProfile.ECSP.InvestmentsOutsideStockMarketAnswerOption | null
        subordinated_financial_instruments: App.Enums.ComplianceProfile.ECSP.SubordinatedFinancialInstrumentsAnswerOption | null
        profit_participation_certificate: App.Enums.ComplianceProfile.ECSP.ProfitParticipationCertificateAnswerOption | null
    }
}
export namespace App.Services.ComplianceProfile.ECSP.Categories.Natural {
    export type EcspExperienceDto = {
        no_answer: boolean
        financial_education: App.Enums.ComplianceProfile.ECSP.FinancialEducation | null
        bonds_knowledge: App.Enums.ComplianceProfile.ECSP.YesNoDenyOption | null
        bonds_investment_frequency: App.Enums.ComplianceProfile.ECSP.InvestmentFrequencyOption | null
        stocks_knowledge: App.Enums.ComplianceProfile.ECSP.YesNoDenyOption | null
        stocks_investment_frequency: App.Enums.ComplianceProfile.ECSP.InvestmentFrequencyOption | null
        convertible_bonds_knowledge: App.Enums.ComplianceProfile.ECSP.YesNoDenyOption | null
        convertible_bonds_investment_frequency: App.Enums.ComplianceProfile.ECSP.InvestmentFrequencyOption | null
    }
    export type EcspInvestmentGoalsDto = {
        no_answer: boolean | null
        sustainability: App.Enums.ComplianceProfile.ECSP.SustainabilityAnswerOption | null
        investment_goal: App.Enums.ComplianceProfile.ECSP.InvestmentGoalAnswerOption | null
        investment_horizon: App.Enums.ComplianceProfile.ECSP.InvestmentHorizonAnswerOption | null
    }
}
